<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
                <label for="date_at">Desde/Hasta</label>
                <InputText
                  v-model="start_at"
                  id="date_at"
                  type="date"
                  class="inputfield ml-1"
                />
                <InputText
                  v-model="end_at"
                  id="date_at"
                  type="date"
                  class="inputfield ml-1"
                />
                            
              <Button
                label="Filtrar"
                icon="pi pi-filter"
                class="p-button-help ml-1"
                @click="filterResults()"
              />   
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="data"
          v-model:selection="selectedData"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Movimientos"
          responsiveLayout="scroll"
        >
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0">Movimientos de Insumos</h5>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>


          <Column
            field="fecha"
            header="Fecha"
            :sortable="true"
            headerStyle="width:30%; min-width:12rem;"
          >
            <template #body="slotProps">
              <span>
                  {{ slotProps.data.fecha }}
              </span> 
            </template>
        </Column>


        <Column
          field="description"
          header="Descripción"
          :sortable="true"
          headerStyle="width:40%; min-width:10rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">Descripción</span>
            {{ slotProps.data.description }}
          </template>
        </Column>

        <Column
          field="insumo_descr"
          header="Insumo"
          :sortable="true"
          headerStyle="width:40%; min-width:10rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">Insumo</span>
            {{ slotProps.data.insumo_descr }}
          </template>
        </Column>

        <Column
          field="user"
          header="Solicitado por"
          :sortable="true"
          >
          <template #body="slotProps">
            <span class="p-column-title">Solicitado por</span>
            {{ giveMeUser(slotProps.data.user_id) }}
          </template>
        </Column>

        <Column
          field="approved_user"
          header="Aprobado por"
          :sortable="true"
          >
          <template #body="slotProps">
            <span class="p-column-title">Aprobado por</span>
            {{ giveMeUser(slotProps.data.approved_user_id) }}
          </template>
        </Column>

        <Column
          field="quantity_old"
          header="Cant. Anterior"
          :sortable="true"
          headerStyle="width:40%; min-width:11rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">Cant. Anterior</span>
            {{ slotProps.data.quantity_old }}
          </template>
        </Column>

        <Column
          field="quantity_new"
          header="Cant. Nueva"
          :sortable="true"
          headerStyle="width:40%; min-width:11rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">Cant. Nueva</span>
            {{ slotProps.data.quantity_new }}
          </template>
        </Column>
         
        </DataTable>

        <Dialog
          v-model:visible="itemDialog"
          :style="{ width: '450px' }"
          header="Solicitud de Insumos"
          :modal="true"
          class="p-fluid"
        >
          <div class="field">
            <label for="name">Observaciones </label>
            <InputText
              id="observations"
              v-model.trim="item.observations"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !item.observations }"
            />            
          </div>

          
          

          <template #footer>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteItemDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item"
              >Eliminaras a <b>{{ item.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteItemDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteDataDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item">Seguro?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDataDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedData"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import CrudService from "../services/crud.service";
import UserService from "../services/user.service";

export default {
  data() {
    return {
      routeName: null,
      data: [],
      itemDialog: false,
      deleteItemDialog: false,
      deleteDataDialog: false,
      item: {id:null, oti_id:null, observations:'',  status:''},
      selectedData: null,
      filters: {},
      submitted: false,
      validationErrors: null,
      otis: [],
      detalle: [],
      insumos: [],
      users: [],
      newItemInsumo: null,
      quantity: 0,
      filteredInsumo: null,
      selectedInsumo : null,
      deposito: null,
      start_at: null,
      end_at: null
    };
  },
  created() {
    this.routeName = this.$route.name;
     
    this.initFilters();
  },
  mounted() {
    CrudService.getCRUD('usuario', 'usuario').then((data) => this.users = data);
    CrudService.getCRUD('reporte-insumos', 'reporte-insumos').then(
      (data) => {
        data.forEach((item) => {
          item.fecha = this.formatDate(item.created_at);
          item.insumo_descr = item.insumo?.name;
          item.descripcion = item.description;
          item.description = item.description;
          item.cant_old = item.quantity_old;
          item.user_id = item.user_id;
          item.approved_user_id = item.approved_user_id;
          item.cant_new = item.quantity_new;
        });      
        this.data = data;
      }
    );    
  },
  methods: { 
    giveMeUser (user_id) {
      let user = this.users.filter((item) => item.id == user_id);
      if (user.length) {
        return user[0].name;
      }
    },
    filterResults() {
      let dates = { start_at: this.start_at, end_at: this.end_at }
      CrudService.createCRUD('reporte-insumos', 'reporte-insumos', dates).then(
        (data) => {
          console.log('data')
          console.log(data)
          
          data.forEach((item) => {
            item.fecha = this.formatDate(item.created_at);
            item.insumo_descr = item.insumo?.name;
            item.descripcion = item.description;
            item.description = item.description;
            item.cant_old = item.quantity_old;
            item.cant_new = item.quantity_new;
          });
        
          this.data = data;
          console.log('this.data')
          console.log(this.data)

        }
      );
    },
    formatDate(date_at) {
      return new Date(date_at).toLocaleString(); //date_at;
    },
    selectProduct(selectedInsumo) {
      this.newItemInsumo = selectedInsumo;
      this.quantity = this.newItemInsumo.quantity;
    },
    delItemInsumo(itemId) {
      let index = this.detalle.findIndex(item => item.id == itemId);
      this.detalle.splice(index, 1);
    }, 
    searchInsumo(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredInsumo = [...this.insumos];
        } else {
          this.filteredInsumo = this.insumos.filter((insumo) => {
            return insumo.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    addItemDetalle() {
      if (this.quantity <= 0) {
        this.$toast.add({
                severity: "error",
                summary: "Error!",
                detail: "Debe ingresar la cantidad.",
                life: 3000,
              });
        return false;
      }
      if (! this.newItemInsumo) {
        this.$toast.add({
                severity: "error",
                summary: "Error!",
                detail: "Debe seleccionar el insumo a agregar.",
                life: 3000,
              });
        return false;
      }
      if (this.quantity > this.newItemInsumo.quantity) {
        this.$toast.add({
                severity: "error",
                summary: "Atención!",
                detail: "La Cantidad solicitada es superior al Stock actual!",
                life: 3000,
              });
      }
      
      this.detalle.push({
        id: this.newItemInsumo.id,
        name: this.newItemInsumo.name,
        quantity: this.quantity
      });
      this.actualFormulaUser = null;
      this.newItemInsumo = null;
      this.selectedInsumo = null;
      this.quantity = 0;
    },
    openNew() {
      this.item = {};
      this.detalle = [];
      
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    displayErrors(errors) {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    requestUpdate(url=null) {
      let routeName = this.routeName;
      let updateValue = null;
      if (url) {
        routeName = url;
        updateValue = true;
      }
      CrudService.updateCRUD(routeName, routeName, this.item).then((response) => {        
        if (response.status == 400) { 
          this.displayErrors(response.data);
          return false;
        } 
        this.$toast.add({
          severity: "success",
          summary: "Éxito!",
          detail: "Actualizado correctamente.",
          life: 3000,
        });
        this.data[this.findIndexById(this.item.id)] = this.item;
        if (updateValue) {
          this.data[this.findIndexById(this.item.id)] = response.data;
        }
        this.data[this.findIndexById(this.item.id)].detalle = [];
        
        response.data.detalle.forEach((item) => {
          this.data[this.findIndexById(this.item.id)].detalle.push(item);                
        });
        
        this.initFields();
      });
    },
    requestCreate() {
      CrudService.createCRUD(this.routeName, this.routeName, this.item).then((response) => {              
        if (response.status == 400) { 
          this.displayErrors(response.data);              
          return false;
        }
        this.data.push(response.data);
        this.$toast.add({
          severity: "success",
          summary: "Éxito!",
          detail: "Creado correctamente.",
          life: 3000,
        });
        this.initFields();
      });
    },
    saveItem() {
      this.submitted = true;
      
      if (! this.detalle) {
        this.$toast.add({
          severity: "danger",
          summary: "Atención!",
          detail: "Debe ingresar los insumos a solicitar.",
          life: 3000,
        });
      }
      this.validationErrors = [];
      this.item.details = this.detalle;
      if (this.item.id) {
        this.requestUpdate();
        return false;
      } 

      this.requestCreate();
    },
    approveItem(item) {
      this.submitted = true;
      
      this.validationErrors = [];
      this.item = item;
      this.requestUpdate('aprobar-solicitud');
    },
    rejectItem(item) {
      this.submitted = true;
      
      this.validationErrors = [];
      this.item = item;
      this.requestUpdate('rechazar-solicitud');
    },
    initFields() {
      this.itemDialog = false;
      this.item = {};
      this.detalle = [];
    },
    isPendingStatus(item) {      
      return item.status == 'PENDIENTE';
    },
    editItem(item) {
      this.detalle = [];
      this.item = { ...item };
      this.item.detalle.forEach((item) => {
        let obj = {
          quantity: item?.quantity,
          name: item.insumo?.name,
          id: item.insumo?.id
        };
        this.detalle.push(obj);
      });
      this.itemDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItem() {
      CrudService.deleteCRUD(this.routeName, this.routeName, this.item.id).then(
        (response) => {
          //this.data.splice(this.findIndexById(data.data.id), 1);
          this.data = this.data.filter((item) => item.id != response.data);
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Éxito!",
            detail: "Eliminado correctamente.",
            life: 3000,
          });
        }
      );

      this.deleteItemDialog = false;
      this.item = {};
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteDataDialog = true;
    },
    deleteSelectedData() {
      this.data = this.data.filter(
        (val) => !this.selectedData.includes(val)
      );
      this.deleteDataDialog = false;
      this.selectedData = null;
      this.$toast.add({
        severity: "success",
        summary: "Éxito!",
        detail: "Eliminado correctamente.",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.product-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.product-badge.status-aprobado {
    background: #c8e6c9;
    color: #256029;
}

.product-badge.status-pendiente {
    background: #feedaf;
    color: #8a5340;
}

.product-badge.status-rechazado {
    background: #ffcdd2;
    color: #c63737;
}
</style>
